import { defineComponent as ge, ref as T, computed as Z, openBlock as I, createElementBlock as P, normalizeClass as ie, normalizeStyle as Ze, unref as g, createElementVNode as W, inject as Yt, Fragment as De, renderList as nt, toDisplayString as ne, renderSlot as Ve, createBlock as re, createCommentVNode as K, createVNode as xe, createTextVNode as Pe, pushScopeId as dn, popScopeId as hn, watch as at, nextTick as pt, provide as fn, toRef as Ae, watchEffect as vn, onBeforeMount as mn, onUnmounted as yn, withCtx as gt } from "vue";
var be = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function $e(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Bt = { exports: {} };
(function(e, a) {
  (function(n, t) {
    e.exports = t();
  })(be, function() {
    var n = 1e3, t = 6e4, o = 36e5, c = "millisecond", s = "second", m = "minute", y = "hour", _ = "day", Y = "week", b = "month", u = "quarter", A = "year", x = "date", i = "Invalid Date", w = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, z = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, S = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(p) {
      var v = ["th", "st", "nd", "rd"], d = p % 100;
      return "[" + p + (v[(d - 20) % 10] || v[d] || v[0]) + "]";
    } }, F = function(p, v, d) {
      var k = String(p);
      return !k || k.length >= v ? p : "" + Array(v + 1 - k.length).join(d) + p;
    }, H = { s: F, z: function(p) {
      var v = -p.utcOffset(), d = Math.abs(v), k = Math.floor(d / 60), f = d % 60;
      return (v <= 0 ? "+" : "-") + F(k, 2, "0") + ":" + F(f, 2, "0");
    }, m: function p(v, d) {
      if (v.date() < d.date())
        return -p(d, v);
      var k = 12 * (d.year() - v.year()) + (d.month() - v.month()), f = v.clone().add(k, b), D = d - f < 0, $ = v.clone().add(k + (D ? -1 : 1), b);
      return +(-(k + (d - f) / (D ? f - $ : $ - f)) || 0);
    }, a: function(p) {
      return p < 0 ? Math.ceil(p) || 0 : Math.floor(p);
    }, p: function(p) {
      return { M: b, y: A, w: Y, d: _, D: x, h: y, m, s, ms: c, Q: u }[p] || String(p || "").toLowerCase().replace(/s$/, "");
    }, u: function(p) {
      return p === void 0;
    } }, N = "en", U = {};
    U[N] = S;
    var V = "$isDayjsObject", X = function(p) {
      return p instanceof Ie || !(!p || !p[V]);
    }, ee = function p(v, d, k) {
      var f;
      if (!v)
        return N;
      if (typeof v == "string") {
        var D = v.toLowerCase();
        U[D] && (f = D), d && (U[D] = d, f = D);
        var $ = v.split("-");
        if (!f && $.length > 1)
          return p($[0]);
      } else {
        var L = v.name;
        U[L] = v, f = L;
      }
      return !k && f && (N = f), f || !k && N;
    }, q = function(p, v) {
      if (X(p))
        return p.clone();
      var d = typeof v == "object" ? v : {};
      return d.date = p, d.args = arguments, new Ie(d);
    }, B = H;
    B.l = ee, B.i = X, B.w = function(p, v) {
      return q(p, { locale: v.$L, utc: v.$u, x: v.$x, $offset: v.$offset });
    };
    var Ie = function() {
      function p(d) {
        this.$L = ee(d.locale, null, !0), this.parse(d), this.$x = this.$x || d.x || {}, this[V] = !0;
      }
      var v = p.prototype;
      return v.parse = function(d) {
        this.$d = function(k) {
          var f = k.date, D = k.utc;
          if (f === null)
            return /* @__PURE__ */ new Date(NaN);
          if (B.u(f))
            return /* @__PURE__ */ new Date();
          if (f instanceof Date)
            return new Date(f);
          if (typeof f == "string" && !/Z$/i.test(f)) {
            var $ = f.match(w);
            if ($) {
              var L = $[2] - 1 || 0, R = ($[7] || "0").substring(0, 3);
              return D ? new Date(Date.UTC($[1], L, $[3] || 1, $[4] || 0, $[5] || 0, $[6] || 0, R)) : new Date($[1], L, $[3] || 1, $[4] || 0, $[5] || 0, $[6] || 0, R);
            }
          }
          return new Date(f);
        }(d), this.init();
      }, v.init = function() {
        var d = this.$d;
        this.$y = d.getFullYear(), this.$M = d.getMonth(), this.$D = d.getDate(), this.$W = d.getDay(), this.$H = d.getHours(), this.$m = d.getMinutes(), this.$s = d.getSeconds(), this.$ms = d.getMilliseconds();
      }, v.$utils = function() {
        return B;
      }, v.isValid = function() {
        return this.$d.toString() !== i;
      }, v.isSame = function(d, k) {
        var f = q(d);
        return this.startOf(k) <= f && f <= this.endOf(k);
      }, v.isAfter = function(d, k) {
        return q(d) < this.startOf(k);
      }, v.isBefore = function(d, k) {
        return this.endOf(k) < q(d);
      }, v.$g = function(d, k, f) {
        return B.u(d) ? this[k] : this.set(f, d);
      }, v.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, v.valueOf = function() {
        return this.$d.getTime();
      }, v.startOf = function(d, k) {
        var f = this, D = !!B.u(k) || k, $ = B.p(d), L = function(se, j) {
          var oe = B.w(f.$u ? Date.UTC(f.$y, j, se) : new Date(f.$y, j, se), f);
          return D ? oe : oe.endOf(_);
        }, R = function(se, j) {
          return B.w(f.toDate()[se].apply(f.toDate("s"), (D ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(j)), f);
        }, G = this.$W, C = this.$M, Q = this.$D, ae = "set" + (this.$u ? "UTC" : "");
        switch ($) {
          case A:
            return D ? L(1, 0) : L(31, 11);
          case b:
            return D ? L(1, C) : L(0, C + 1);
          case Y:
            var ue = this.$locale().weekStart || 0, fe = (G < ue ? G + 7 : G) - ue;
            return L(D ? Q - fe : Q + (6 - fe), C);
          case _:
          case x:
            return R(ae + "Hours", 0);
          case y:
            return R(ae + "Minutes", 1);
          case m:
            return R(ae + "Seconds", 2);
          case s:
            return R(ae + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, v.endOf = function(d) {
        return this.startOf(d, !1);
      }, v.$set = function(d, k) {
        var f, D = B.p(d), $ = "set" + (this.$u ? "UTC" : ""), L = (f = {}, f[_] = $ + "Date", f[x] = $ + "Date", f[b] = $ + "Month", f[A] = $ + "FullYear", f[y] = $ + "Hours", f[m] = $ + "Minutes", f[s] = $ + "Seconds", f[c] = $ + "Milliseconds", f)[D], R = D === _ ? this.$D + (k - this.$W) : k;
        if (D === b || D === A) {
          var G = this.clone().set(x, 1);
          G.$d[L](R), G.init(), this.$d = G.set(x, Math.min(this.$D, G.daysInMonth())).$d;
        } else
          L && this.$d[L](R);
        return this.init(), this;
      }, v.set = function(d, k) {
        return this.clone().$set(d, k);
      }, v.get = function(d) {
        return this[B.p(d)]();
      }, v.add = function(d, k) {
        var f, D = this;
        d = Number(d);
        var $ = B.p(k), L = function(C) {
          var Q = q(D);
          return B.w(Q.date(Q.date() + Math.round(C * d)), D);
        };
        if ($ === b)
          return this.set(b, this.$M + d);
        if ($ === A)
          return this.set(A, this.$y + d);
        if ($ === _)
          return L(1);
        if ($ === Y)
          return L(7);
        var R = (f = {}, f[m] = t, f[y] = o, f[s] = n, f)[$] || 1, G = this.$d.getTime() + d * R;
        return B.w(G, this);
      }, v.subtract = function(d, k) {
        return this.add(-1 * d, k);
      }, v.format = function(d) {
        var k = this, f = this.$locale();
        if (!this.isValid())
          return f.invalidDate || i;
        var D = d || "YYYY-MM-DDTHH:mm:ssZ", $ = B.z(this), L = this.$H, R = this.$m, G = this.$M, C = f.weekdays, Q = f.months, ae = f.meridiem, ue = function(j, oe, de, we) {
          return j && (j[oe] || j(k, D)) || de[oe].slice(0, we);
        }, fe = function(j) {
          return B.s(L % 12 || 12, j, "0");
        }, se = ae || function(j, oe, de) {
          var we = j < 12 ? "AM" : "PM";
          return de ? we.toLowerCase() : we;
        };
        return D.replace(z, function(j, oe) {
          return oe || function(de) {
            switch (de) {
              case "YY":
                return String(k.$y).slice(-2);
              case "YYYY":
                return B.s(k.$y, 4, "0");
              case "M":
                return G + 1;
              case "MM":
                return B.s(G + 1, 2, "0");
              case "MMM":
                return ue(f.monthsShort, G, Q, 3);
              case "MMMM":
                return ue(Q, G);
              case "D":
                return k.$D;
              case "DD":
                return B.s(k.$D, 2, "0");
              case "d":
                return String(k.$W);
              case "dd":
                return ue(f.weekdaysMin, k.$W, C, 2);
              case "ddd":
                return ue(f.weekdaysShort, k.$W, C, 3);
              case "dddd":
                return C[k.$W];
              case "H":
                return String(L);
              case "HH":
                return B.s(L, 2, "0");
              case "h":
                return fe(1);
              case "hh":
                return fe(2);
              case "a":
                return se(L, R, !0);
              case "A":
                return se(L, R, !1);
              case "m":
                return String(R);
              case "mm":
                return B.s(R, 2, "0");
              case "s":
                return String(k.$s);
              case "ss":
                return B.s(k.$s, 2, "0");
              case "SSS":
                return B.s(k.$ms, 3, "0");
              case "Z":
                return $;
            }
            return null;
          }(j) || $.replace(":", "");
        });
      }, v.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, v.diff = function(d, k, f) {
        var D, $ = this, L = B.p(k), R = q(d), G = (R.utcOffset() - this.utcOffset()) * t, C = this - R, Q = function() {
          return B.m($, R);
        };
        switch (L) {
          case A:
            D = Q() / 12;
            break;
          case b:
            D = Q();
            break;
          case u:
            D = Q() / 3;
            break;
          case Y:
            D = (C - G) / 6048e5;
            break;
          case _:
            D = (C - G) / 864e5;
            break;
          case y:
            D = C / o;
            break;
          case m:
            D = C / t;
            break;
          case s:
            D = C / n;
            break;
          default:
            D = C;
        }
        return f ? D : B.a(D);
      }, v.daysInMonth = function() {
        return this.endOf(b).$D;
      }, v.$locale = function() {
        return U[this.$L];
      }, v.locale = function(d, k) {
        if (!d)
          return this.$L;
        var f = this.clone(), D = ee(d, k, !0);
        return D && (f.$L = D), f;
      }, v.clone = function() {
        return B.w(this.$d, this);
      }, v.toDate = function() {
        return new Date(this.valueOf());
      }, v.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, v.toISOString = function() {
        return this.$d.toISOString();
      }, v.toString = function() {
        return this.$d.toUTCString();
      }, p;
    }(), je = Ie.prototype;
    return q.prototype = je, [["$ms", c], ["$s", s], ["$m", m], ["$H", y], ["$W", _], ["$M", b], ["$y", A], ["$D", x]].forEach(function(p) {
      je[p[1]] = function(v) {
        return this.$g(v, p[0], p[1]);
      };
    }), q.extend = function(p, v) {
      return p.$i || (p(v, Ie, q), p.$i = !0), q;
    }, q.locale = ee, q.isDayjs = X, q.unix = function(p) {
      return q(1e3 * p);
    }, q.en = U[N], q.Ls = U, q.p = {}, q;
  });
})(Bt);
var At = Bt.exports;
const M = /* @__PURE__ */ $e(At);
var Ht = { exports: {} };
(function(e, a) {
  (function(n, t) {
    e.exports = t();
  })(be, function() {
    return function(n, t, o) {
      t.prototype.isBetween = function(c, s, m, y) {
        var _ = o(c), Y = o(s), b = (y = y || "()")[0] === "(", u = y[1] === ")";
        return (b ? this.isAfter(_, m) : !this.isBefore(_, m)) && (u ? this.isBefore(Y, m) : !this.isAfter(Y, m)) || (b ? this.isBefore(_, m) : !this.isAfter(_, m)) && (u ? this.isAfter(Y, m) : !this.isBefore(Y, m));
      };
    };
  });
})(Ht);
var kn = Ht.exports;
const Dn = /* @__PURE__ */ $e(kn);
var Nt = { exports: {} };
(function(e, a) {
  (function(n, t) {
    e.exports = t();
  })(be, function() {
    return function(n, t) {
      t.prototype.isSameOrAfter = function(o, c) {
        return this.isSame(o, c) || this.isAfter(o, c);
      };
    };
  });
})(Nt);
var pn = Nt.exports;
const gn = /* @__PURE__ */ $e(pn);
var jt = { exports: {} };
(function(e, a) {
  (function(n, t) {
    e.exports = t();
  })(be, function() {
    return function(n, t) {
      t.prototype.isSameOrBefore = function(o, c) {
        return this.isSame(o, c) || this.isBefore(o, c);
      };
    };
  });
})(jt);
var bn = jt.exports;
const wn = /* @__PURE__ */ $e(bn);
var zt = { exports: {} };
(function(e, a) {
  (function(n, t) {
    e.exports = t();
  })(be, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, t = {};
    return function(o, c, s) {
      var m, y = function(u, A, x) {
        x === void 0 && (x = {});
        var i = new Date(u), w = function(z, S) {
          S === void 0 && (S = {});
          var F = S.timeZoneName || "short", H = z + "|" + F, N = t[H];
          return N || (N = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: z, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: F }), t[H] = N), N;
        }(A, x);
        return w.formatToParts(i);
      }, _ = function(u, A) {
        for (var x = y(u, A), i = [], w = 0; w < x.length; w += 1) {
          var z = x[w], S = z.type, F = z.value, H = n[S];
          H >= 0 && (i[H] = parseInt(F, 10));
        }
        var N = i[3], U = N === 24 ? 0 : N, V = i[0] + "-" + i[1] + "-" + i[2] + " " + U + ":" + i[4] + ":" + i[5] + ":000", X = +u;
        return (s.utc(V).valueOf() - (X -= X % 1e3)) / 6e4;
      }, Y = c.prototype;
      Y.tz = function(u, A) {
        u === void 0 && (u = m);
        var x = this.utcOffset(), i = this.toDate(), w = i.toLocaleString("en-US", { timeZone: u }), z = Math.round((i - new Date(w)) / 1e3 / 60), S = s(w, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(i.getTimezoneOffset() / 15) - z, !0);
        if (A) {
          var F = S.utcOffset();
          S = S.add(x - F, "minute");
        }
        return S.$x.$timezone = u, S;
      }, Y.offsetName = function(u) {
        var A = this.$x.$timezone || s.tz.guess(), x = y(this.valueOf(), A, { timeZoneName: u }).find(function(i) {
          return i.type.toLowerCase() === "timezonename";
        });
        return x && x.value;
      };
      var b = Y.startOf;
      Y.startOf = function(u, A) {
        if (!this.$x || !this.$x.$timezone)
          return b.call(this, u, A);
        var x = s(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return b.call(x, u, A).tz(this.$x.$timezone, !0);
      }, s.tz = function(u, A, x) {
        var i = x && A, w = x || A || m, z = _(+s(), w);
        if (typeof u != "string")
          return s(u).tz(w);
        var S = function(U, V, X) {
          var ee = U - 60 * V * 1e3, q = _(ee, X);
          if (V === q)
            return [ee, V];
          var B = _(ee -= 60 * (q - V) * 1e3, X);
          return q === B ? [ee, q] : [U - 60 * Math.min(q, B) * 1e3, Math.max(q, B)];
        }(s.utc(u, i).valueOf(), z, w), F = S[0], H = S[1], N = s(F).utcOffset(H);
        return N.$x.$timezone = w, N;
      }, s.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, s.tz.setDefault = function(u) {
        m = u;
      };
    };
  });
})(zt);
var $n = zt.exports;
const In = /* @__PURE__ */ $e($n);
var Lt = { exports: {} };
(function(e, a) {
  (function(n, t) {
    e.exports = t();
  })(be, function() {
    return function(n, t) {
      t.prototype.weekday = function(o) {
        var c = this.$locale().weekStart || 0, s = this.$W, m = (s < c ? s + 7 : s) - c;
        return this.$utils().u(o) ? m : this.subtract(m, "day").add(o, "day");
      };
    };
  });
})(Lt);
var On = Lt.exports;
const Mn = /* @__PURE__ */ $e(On);
var Et = { exports: {} };
(function(e, a) {
  (function(n, t) {
    e.exports = t();
  })(be, function() {
    var n = "minute", t = /[+-]\d\d(?::?\d\d)?/g, o = /([+-]|\d\d)/g;
    return function(c, s, m) {
      var y = s.prototype;
      m.utc = function(i) {
        var w = { date: i, utc: !0, args: arguments };
        return new s(w);
      }, y.utc = function(i) {
        var w = m(this.toDate(), { locale: this.$L, utc: !0 });
        return i ? w.add(this.utcOffset(), n) : w;
      }, y.local = function() {
        return m(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var _ = y.parse;
      y.parse = function(i) {
        i.utc && (this.$u = !0), this.$utils().u(i.$offset) || (this.$offset = i.$offset), _.call(this, i);
      };
      var Y = y.init;
      y.init = function() {
        if (this.$u) {
          var i = this.$d;
          this.$y = i.getUTCFullYear(), this.$M = i.getUTCMonth(), this.$D = i.getUTCDate(), this.$W = i.getUTCDay(), this.$H = i.getUTCHours(), this.$m = i.getUTCMinutes(), this.$s = i.getUTCSeconds(), this.$ms = i.getUTCMilliseconds();
        } else
          Y.call(this);
      };
      var b = y.utcOffset;
      y.utcOffset = function(i, w) {
        var z = this.$utils().u;
        if (z(i))
          return this.$u ? 0 : z(this.$offset) ? b.call(this) : this.$offset;
        if (typeof i == "string" && (i = function(N) {
          N === void 0 && (N = "");
          var U = N.match(t);
          if (!U)
            return null;
          var V = ("" + U[0]).match(o) || ["-", 0, 0], X = V[0], ee = 60 * +V[1] + +V[2];
          return ee === 0 ? 0 : X === "+" ? ee : -ee;
        }(i), i === null))
          return this;
        var S = Math.abs(i) <= 16 ? 60 * i : i, F = this;
        if (w)
          return F.$offset = S, F.$u = i === 0, F;
        if (i !== 0) {
          var H = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (F = this.local().add(S + H, n)).$offset = S, F.$x.$localOffset = H;
        } else
          F = this.utc();
        return F;
      };
      var u = y.format;
      y.format = function(i) {
        var w = i || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return u.call(this, w);
      }, y.valueOf = function() {
        var i = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * i;
      }, y.isUTC = function() {
        return !!this.$u;
      }, y.toISOString = function() {
        return this.toDate().toISOString();
      }, y.toString = function() {
        return this.toDate().toUTCString();
      };
      var A = y.toDate;
      y.toDate = function(i) {
        return i === "s" && this.$offset ? m(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : A.call(this);
      };
      var x = y.diff;
      y.diff = function(i, w, z) {
        if (i && this.$u === i.$u)
          return x.call(this, i, w, z);
        var S = this.local(), F = m(i).local();
        return x.call(S, F, w, z);
      };
    };
  });
})(Et);
var _n = Et.exports;
const xn = /* @__PURE__ */ $e(_n);
var Cn = { exports: {} };
(function(e, a) {
  (function(n, t) {
    e.exports = t(At);
  })(be, function(n) {
    function t(s) {
      return s && typeof s == "object" && "default" in s ? s : { default: s };
    }
    var o = t(n), c = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(s) {
      return "" + s + (s === 1 ? "er" : "");
    } };
    return o.default.locale(c, null, !0), c;
  });
})(Cn);
M.extend(Dn);
M.extend(gn);
M.extend(wn);
M.extend(xn);
M.extend(Mn);
M.extend(In);
const E = (e, a) => M(e).format(a), Sn = (e) => M(e).month(), bt = (e) => M(e).year(), tt = (e) => M(e).format(), Pt = (e) => M(e).toDate(), Tn = (e, a) => {
  const n = M(e), t = M(a);
  return n.isAfter(t, "day");
}, Yn = (e, a) => {
  const n = M(e), t = M(a);
  return n.isSameOrAfter(t, "day");
}, Bn = (e, a) => {
  const n = M(e), t = M(a);
  return n.isBefore(t, "day");
}, An = (e, a) => {
  const n = M(e), t = M(a);
  return n.isSameOrBefore(t, "day");
}, Ne = (e, a, n) => {
  const t = M(e), o = M(a);
  return Math.abs(t.diff(o, n));
}, Ft = (e, a, n, t = !1) => {
  const o = M(e), c = M(a), s = M(n);
  return t ? M(s).isBetween(o, c, "day", "[)") : M(s).isBetween(o, c, "day");
}, Hn = (e, a, n) => M(e).add(a, n).toDate(), Nn = (e, a, n) => M(e).subtract(a, n).toDate(), jn = (e, a) => {
  const n = M(e);
  return n.day() >= a ? n.add(7, "day").day(a).toDate() : n.day(a).toDate();
}, zn = (e, a) => {
  const n = M(e), t = M(a);
  return Ne(n.toDate(), t.toDate(), "day");
}, Ce = (e, a, n) => {
  const t = M(e), o = M(a), c = Ne(t.toDate(), o.toDate(), "day"), s = [];
  for (let m = 0; m < c + 1; m++) {
    const y = t.add(m, "day").format(n);
    s.push(y);
  }
  return s;
}, Ln = (e) => M(e).startOf("month").toDate(), En = (e) => M(e).startOf("month").weekday(0).format("YYYY-MM-DD"), Pn = (e) => M(e).add(1, "month").startOf("month").toDate(), wt = (e, a) => {
  const n = M(e), t = M(a), o = Ne(n.toDate(), t.toDate(), "day"), c = [];
  for (let s = 0; s < o; s++) {
    const m = n.add(s, "day").toDate();
    c.push(m);
  }
  return c;
}, Fn = ["stroke-width"], qn = ["d"], Wn = {
  name: "BaseIcon"
}, pe = /* @__PURE__ */ ge({
  ...Wn,
  props: {
    name: {
      type: String,
      default: ""
    },
    color: {
      type: Array,
      default: () => []
    },
    size: {
      type: Number,
      default: 1.5
    }
  },
  setup(e) {
    const a = e, n = T({
      arrowLeft: "M21 12H3m0 0l8.5-8.5M3 12l8.5 8.5",
      arrowRight: "M3 12h18m0 0l-8.5-8.5M21 12l-8.5 8.5",
      calendar: "M15 4V2m0 2v2m0-2h-4.5M3 10v9a2 2 0 002 2h14a2 2 0 002-2v-9H3zM3 10V6a2 2 0 012-2h2M7 2v4M21 10V6a2 2 0 00-2-2h-.5",
      close: "M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243",
      chevronLeft: "M15 6l-6 6 6 6",
      chevronRight: "M9 6l6 6-6 6"
    }), t = Z(() => n.value[a.name] ? n.value[a.name] : ""), o = Z(() => 24 / (a.size * 16));
    return (c, s) => (I(), P("svg", {
      class: ie(e.color),
      style: Ze({
        width: `${e.size}rem`,
        height: `${e.size}rem`
      }),
      "stroke-width": g(o),
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24"
    }, [
      W("path", {
        "clip-rule": "evenodd",
        d: g(t)
      }, null, 8, qn)
    ], 14, Fn));
  }
}), Un = { class: "calendar_wrapper_content-header-days" }, Vn = {
  name: "CalendarDays"
}, qt = /* @__PURE__ */ ge({
  ...Vn,
  props: {
    locale: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const a = e, n = Yt("t", (c) => ({})), t = T([
      { key: 1, name: "monday" },
      { key: 2, name: "tuesday" },
      { key: 3, name: "wednesday" },
      { key: 4, name: "thursday" },
      { key: 5, name: "friday" },
      { key: 6, name: "saturday" },
      { key: 0, name: "sunday" }
    ]), o = Z(() => {
      const c = JSON.parse(
        JSON.stringify(t.value)
      );
      return a.locale === "en" ? c.sort((s, m) => s.key - m.key) : t.value;
    });
    return (c, s) => (I(), P("ul", Un, [
      (I(!0), P(De, null, nt(g(o), (m) => (I(), P("li", {
        key: m.key,
        class: "calendar-days"
      }, ne(g(n)(`days.${m.name}`)) + ". ", 1))), 128))
    ]));
  }
}), Rn = { class: "calendar_footer" }, Zn = { class: "calendar_footer--button" }, Jn = { key: 1 }, Gn = {
  name: "CalendarHeaderMobile"
}, $t = /* @__PURE__ */ ge({
  ...Gn,
  props: {
    isMobile: {
      type: Boolean,
      required: !0
    },
    locale: {
      type: String,
      required: !0
    }
  },
  emits: ["close-date-picker", "clear-dates"],
  setup(e, { emit: a }) {
    const n = Yt("t", (c) => ({})), t = () => {
      a("close-date-picker");
    }, o = () => {
      a("clear-dates");
    };
    return (c, s) => (I(), P("div", Rn, [
      Ve(c.$slots, "footer", {}, () => [
        W("div", Zn, [
          W("button", {
            class: "calendar_footer--button-clear",
            style: Ze({ order: e.isMobile ? 1 : 2 }),
            onClick: o
          }, ne(g(n)("clearDates")), 5),
          W("button", {
            class: "calendar_footer--button-close",
            onClick: t
          }, [
            e.isMobile ? (I(), re(pe, {
              key: 0,
              name: "arrowLeft",
              size: 1
            })) : (I(), P("span", Jn, ne(g(n)("close")), 1))
          ])
        ]),
        e.isMobile ? (I(), re(qt, {
          key: 0,
          locale: e.locale
        }, null, 8, ["locale"])) : K("", !0)
      ])
    ]));
  }
}), Kn = {
  name: "CalendarHalfDay"
}, Qn = /* @__PURE__ */ ge({
  ...Kn,
  props: {
    bookingStyle: {
      type: Object,
      default: null
    },
    day: {
      type: Object,
      required: !0
    },
    isCheckIn: {
      type: Boolean,
      required: !0
    },
    isCheckOut: {
      type: Boolean,
      required: !0
    }
  },
  setup(e) {
    const a = e, n = (t) => {
      const o = a.isCheckIn ? "checkIn" : "checkOut";
      if (a.bookingStyle) {
        const c = a.bookingStyle[t];
        if (c && typeof c == "object" && (c.checkIn || c.checkOut))
          return {
            background: c[o],
            border: "1px solid white"
          };
        if (typeof c == "string")
          return {
            background: c,
            border: ""
          };
      }
      return {
        background: "",
        border: ""
      };
    };
    return (t, o) => (I(), P("i", {
      style: Ze(n(e.day.formatDay)),
      class: ie([
        "calendar_day_haldDay",
        {
          "calendar_day_haldDay--checkIn": e.isCheckIn,
          "calendar_day_haldDay--checkOut": e.isCheckOut
        }
      ])
    }, null, 6));
  }
}), Wt = (e, a) => {
  const n = e.__vccOpts || e;
  for (const [t, o] of a)
    n[t] = o;
  return n;
}, Fe = /* @__PURE__ */ Wt(Qn, [["__scopeId", "data-v-ed1cb25f"]]), Xn = { class: "calendar_header-left" }, ea = ["disabled"], ta = {
  key: 0,
  class: "calendar_header-text"
}, na = {
  key: 0,
  class: "text-center"
}, aa = { class: "calendar_header-right" }, ra = {
  key: 0,
  class: "calendar_header-text"
}, oa = ["disabled"], sa = {
  name: "CalendarHeader"
}, ca = /* @__PURE__ */ ge({
  ...sa,
  props: {
    activeIndex: {
      type: Number,
      default: 0
    },
    showHeader: {
      type: Boolean,
      default: !1
    },
    months: {
      type: Array,
      default: () => []
    }
  },
  emits: ["paginate"],
  setup(e, { emit: a }) {
    const n = e, t = Z(() => {
      var s;
      if ((s = n.months[n.activeIndex]) != null && s.monthName)
        return n.months[n.activeIndex].monthName;
      throw new Error(
        `Month name not found with index: ${n.activeIndex} and month: ${JSON.stringify(n.months)}`
      );
    }), o = Z(() => n.months[n.activeIndex + 1].monthName), c = (s) => {
      a("paginate", s);
    };
    return (s, m) => (I(), P("div", {
      class: ie(["calendar_header", { calendar_header_mobile: e.showHeader }])
    }, [
      W("div", Xn, [
        W("button", {
          type: "button",
          "data-testid": "button-prev-month",
          disabled: e.activeIndex === 0,
          class: "calendar_header-left-button",
          onClick: m[0] || (m[0] = (y) => c("-"))
        }, [
          xe(pe, { name: "chevronLeft" })
        ], 8, ea),
        e.showHeader ? K("", !0) : (I(), P("p", ta, ne(g(t)), 1))
      ]),
      e.showHeader ? (I(), P("p", na, ne(g(t)), 1)) : K("", !0),
      W("div", aa, [
        e.showHeader ? K("", !0) : (I(), P("p", ra, ne(g(o)), 1)),
        W("button", {
          type: "button",
          "data-testid": "button-next-month",
          disabled: e.activeIndex >= e.months.length - 2,
          class: "calendar_header-right-button",
          onClick: m[1] || (m[1] = (y) => c("+"))
        }, [
          xe(pe, { name: "chevronRight" })
        ], 8, oa)
      ])
    ], 2));
  }
}), la = { class: "calendar_input" }, ia = { class: "calendar_input-text" }, ua = {
  name: "CalendarInput"
}, da = /* @__PURE__ */ ge({
  ...ua,
  props: {
    checkIn: {
      type: [Date, String],
      default: null
    },
    checkOut: {
      type: [Date, String],
      default: null
    },
    dayFormat: {
      type: Function,
      required: !0
    },
    placeholder: {
      type: Object,
      required: !0
    },
    singleCalendar: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["clear-dates", "open-calendar"],
  setup(e, { emit: a }) {
    const n = () => {
      a("open-calendar");
    }, t = () => {
      a("clear-dates");
    };
    return (o, c) => (I(), P("div", la, [
      W("div", {
        "data-testid": "calendar_input",
        class: "calendar_input-left-part",
        onClick: n
      }, [
        xe(pe, {
          name: "calendar",
          color: [
            "calendar_input-calendar",
            {
              "calendar_input-calendar--hasnt-checkIn": !e.checkIn,
              "calendar_input-calendar--checkIn": e.checkIn
            }
          ]
        }, null, 8, ["color"]),
        W("p", ia, [
          W("span", {
            "data-testid": "checkIn",
            class: ie([
              {
                "calendar_input-text--hasnt-checkIn": !e.checkIn,
                "calendar_input-text--checkIn": e.checkIn
              }
            ])
          }, [
            e.checkIn ? (I(), P(De, { key: 0 }, [
              Pe(ne(e.dayFormat(e.checkIn)), 1)
            ], 64)) : (I(), P(De, { key: 1 }, [
              Pe(ne(e.placeholder.checkIn), 1)
            ], 64))
          ], 2),
          e.singleCalendar ? K("", !0) : (I(), P(De, { key: 0 }, [
            xe(pe, {
              name: "arrowRight",
              size: 1,
              color: [
                "calendar_input-arrowRight",
                {
                  "calendar_input-arrowRight--hasnt-checkIn": !e.checkIn,
                  "calendar_input-arrowRight--checkIn": e.checkIn
                }
              ]
            }, null, 8, ["color"]),
            W("span", {
              "data-testid": "checkOut",
              class: ie([
                {
                  "calendar_input-text--hasnt-checkIn": !e.checkIn,
                  "calendar_input-text--checkIn": e.checkIn
                }
              ])
            }, [
              e.checkOut ? (I(), P(De, { key: 0 }, [
                Pe(ne(e.dayFormat(e.checkOut)), 1)
              ], 64)) : (I(), P(De, { key: 1 }, [
                Pe(ne(e.placeholder.checkOut), 1)
              ], 64))
            ], 2)
          ], 64))
        ])
      ]),
      e.checkIn ? (I(), re(pe, {
        key: 0,
        name: "close",
        size: 1,
        onClick: t
      })) : K("", !0)
    ]));
  }
}), ha = (e) => (dn("data-v-53fba03f"), e = e(), hn(), e), fa = { class: "calendar_tooltip" }, va = /* @__PURE__ */ ha(() => /* @__PURE__ */ W("i", { class: "calendar_tooltip-arrow" }, null, -1)), ma = {
  name: "CalendarTooltip"
}, ya = /* @__PURE__ */ ge({
  ...ma,
  props: {
    tooltipText: null
  },
  emits: ["remove-tooltip"],
  setup(e, { emit: a }) {
    const n = () => {
      a("remove-tooltip");
    };
    return (t, o) => (I(), P("div", fa, [
      W("div", {
        class: ie([
          "calendar_tooltip--content",
          {
            "calendar_tooltip--content--min": e.tooltipText.length < 25,
            "calendar_tooltip--content--max": e.tooltipText.length > 25
          }
        ]),
        onMouseenter: n
      }, ne(e.tooltipText), 35),
      va
    ]));
  }
}), It = /* @__PURE__ */ Wt(ya, [["__scopeId", "data-v-53fba03f"]]), ka = (e, a = 1) => {
  if (e) {
    let n = e.replace("#", "");
    n.length === 3 && (n = `${n[0]}${n[0]}${n[1]}${n[1]}${n[2]}${n[2]}`);
    const t = parseInt(n.substring(0, 2), 16), o = parseInt(n.substring(2, 4), 16), c = parseInt(n.substring(4, 6), 16);
    return a > 1 && a <= 100 && (a = a / 100), `rgba(${t},${o},${c},${a})`;
  }
  return "";
}, Ot = (e, a) => Tn(e, a), Da = (e, a) => Bn(e, a), Ut = (e, a) => Ne(e, a, "day"), He = (e, a, n) => Ft(e, a, n), Mt = (e, a) => Ne(e, a, "month"), Re = (e, a) => An(e, a), me = (e, a) => Hn(e, a, "day"), qe = (e, a) => Nn(e, a, "day"), _t = (e, a) => jn(e, a), pa = (e) => (e.map((a) => ({
  ...a,
  checkInDate: E(a.checkInDate, "YYYY/MM/DD")
})), e.sort((a, n) => {
  const t = a.checkInDate.split("/").reverse().join(), o = n.checkInDate.split("/").reverse().join();
  return t < o ? -1 : t > o ? 1 : 0;
}).map((a) => ({
  ...a,
  checkInDate: E(a.checkInDate, "YYYY-MM-DD")
}))), ot = (e) => (e.map((a) => E(a, "YYYY/MM/DD")), e.sort((a, n) => {
  const t = a.split("/").reverse().join(), o = n.split("/").reverse().join();
  return t < o ? -1 : t > o ? 1 : 0;
}).map((a) => E(a, "YYYY-MM-DD"))), ga = () => {
  const e = typeof window < "u";
  let a = !1;
  return e && function(n) {
    (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
      n
    ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      n.substr(0, 4)
    )) && (a = !0);
  }(navigator.userAgent || navigator.vendor), a;
}, ba = (e) => {
  let a = "";
  if (e) {
    let n = e.split(/[-_]/g);
    for (let t in n)
      Number(t) > 0 ? a += n[t].charAt(0).toUpperCase() + n[t].slice(1) : a += n[t];
  } else
    return a;
  return a;
}, rt = ({
  startDate: e,
  date: a,
  showYear: n
}) => {
  const t = Sn(a), o = bt(a), c = bt(e), s = o - c > 0 ? o - c : 0, m = n ? s * 12 : s * 12 + t;
  return Math.floor(m);
}, xt = (e, a, n, t) => {
  const o = T({}), c = {};
  e.forEach((y) => {
    const _ = T(
      Ce(
        y.checkInDate,
        y.checkOutDate,
        n.value
      )
    );
    y.type && (c[y.type] ? c[y.type].push(..._.value) : c[y.type] = _.value);
  });
  const s = Object.entries(c), m = (y, _) => {
    var Y, b, u, A;
    if ((Y = t.value[_]) != null && Y.checkIn && ((b = t.value[_]) != null && b.checkOut)) {
      const x = ((u = e.find((w) => w.checkInDate === _)) == null ? void 0 : u.type) || "", i = ((A = e.find((w) => w.checkOutDate === _)) == null ? void 0 : A.type) || "";
      return {
        checkIn: x in a ? a[x] : "#000",
        checkOut: x in a ? a[i] : "#000"
      };
    } else
      return a[y] || "#000000";
  };
  return s.forEach(([y, _]) => {
    _.forEach((Y) => {
      o.value[Y] = m(y, Y);
    });
  }), o;
}, wa = (e) => {
  const a = T({}), n = T(ot([...e]));
  for (let t = 0; t < n.value.length; t++) {
    const o = n.value[t], c = n.value[t + 1];
    t === 0 && (a.value[o] = {
      checkIn: !0
    }), !a.value[o] && n.value[t + 1] && Ut(o, c) > 1 && (a.value[o] = {
      checkOut: !0
    }, a.value[c] = {
      checkIn: !0
    }), t === n.value.length - 1 && (a.value[o] = {
      checkOut: !0
    });
  }
  return {
    bookedDates: n,
    checkIncheckOutHalfDay: a
  };
}, Ct = (e, a) => {
  const n = wa(a).checkIncheckOutHalfDay;
  return e.reduce(
    (o, c) => (o.find((s) => s.checkInDate === c.checkInDate) || o.push(c), o),
    []
  ).forEach((o) => {
    n.value[o.checkInDate] ? n.value[o.checkInDate] = {
      checkOut: !0,
      checkIn: !0
    } : n.value[o.checkInDate] = {
      checkIn: !0
    }, n.value[o.checkOutDate] ? n.value[o.checkOutDate] = {
      checkOut: !0,
      checkIn: !0
    } : n.value[o.checkOutDate] = {
      checkOut: !0
    };
  }), n;
}, St = (e) => {
  const a = T({}), n = T(ot([...e]));
  for (let t = 0; t < n.value.length; t++) {
    const o = n.value[t], c = n.value[t + 1];
    t === 0 && (a.value[o] = {
      checkIn: !0
    }), !a.value[o] && n.value[t + 1] && Ut(o, c) > 1 && (a.value[o] = {
      checkOut: !0
    }, a.value[c] = {
      checkIn: !0
    }), t === n.value.length - 1 && (a.value[o] = {
      checkOut: !0
    });
  }
  return {
    bookedDates: n,
    checkIncheckOutHalfDay: a
  };
}, $a = (e, a) => {
  const n = /* @__PURE__ */ new Set();
  let t = 0;
  const o = {};
  return Object.keys(e.value).forEach(
    (c, s) => {
      t = s, e.value[c].checkIn && (o.checkInDate = c), e.value[c].checkOut && (o.checkOutDate = c), t % 2 === 1 && n.add({
        checkInDate: o.checkInDate,
        checkOutDate: o.checkOutDate
      });
    }
  ), pa([...a, ...n]);
}, We = (e, a, n, t) => {
  const o = T([]), c = T([]), s = {}, m = St(a).bookedDates, y = St(a).checkIncheckOutHalfDay, _ = $a(
    y,
    e
  );
  return e.forEach((b) => {
    y.value[b.checkInDate] = {
      checkIn: !0
    }, y.value[b.checkOutDate] = {
      checkOut: !0
    };
    const u = T(
      Ce(
        b.checkInDate,
        b.checkOutDate,
        t.value
      )
    );
    b.type && (s[b.type] ? s[b.type].push(...u.value) : s[b.type] = u.value);
  }), Object.entries(s).forEach(([b, u]) => {
    c.value.push({
      color: n[b] || "#000000",
      key: b,
      value: u
    });
  }), o.value = c.value.map((b) => b.value).flat(), o.value.push(...m.value), o.value = ot(o.value), {
    flatBookingDates: c,
    checkIncheckOutHalfDay: y,
    disabledDates: o,
    newBookingDates: _
  };
}, Ia = (e) => {
  const a = E(e, "MMMM"), n = E(e, " YYYY");
  return `${a} ${n}`;
}, Oa = (e) => {
  const a = [];
  for (let n = 0; n < e.length; n++) {
    const t = e[n];
    a.push(Vt(t));
  }
  return a;
}, Vt = (e) => {
  const n = Ln(e), t = En(e), o = {
    days: [],
    monthKey: e.getMonth(),
    monthName: Ia(n),
    yearKey: e.getFullYear()
  };
  for (let c = 0; c < 42; c++) {
    const s = me(t, c);
    o.days.push({
      belongsToThisMonth: s.getMonth() === o.monthKey,
      date: s,
      dayIndex: s.getDay(),
      dayNumber: E(s, "D"),
      formatDay: E(s, "YYYY-MM-DD"),
      style: {}
    });
  }
  return o;
}, Ma = (e, a) => {
  let n = Pt(e);
  const t = [];
  for (let o = 0; o < a; o++) {
    const c = Pn(n);
    t.push(c), n = c;
  }
  return Oa(t);
}, Tt = (e, a, n) => {
  const t = T([]), o = {};
  return e.forEach((s) => {
    const m = T(
      Ce(
        s.checkInDate,
        s.checkOutDate,
        n.value
      )
    );
    s.type && (o[s.type] ? o[s.type].push(...m.value) : o[s.type] = m.value);
  }), Object.entries(o).forEach(([s, m]) => {
    t.value.push({
      color: a[s] || "#000000",
      key: s,
      value: m
    });
  }), t;
}, Ue = (e, a, n) => e.value.length > 0 && e.value.some((t) => t.periodType === a) ? [
  ...new Set(
    e.value.filter((t) => t.periodType === a).map((t) => Ce(
      t.startAt,
      t.endAt,
      n
    )).flat()
  )
] : [], _a = (e, a) => Re(a, e), xa = (e, a) => {
  if (e.value.length > 0) {
    const n = E(me(a, 1), "YYYY-MM-DD"), t = e.value.find(
      (o) => _a(o.checkInDate, n) || He(
        o.checkInDate,
        o.checkOutDate,
        n
      )
    );
    if (t && t.checkInDate)
      return Pt(t.checkInDate);
  }
  return null;
}, Ca = (e, a) => {
  if (e.value.length > 0)
    return e.value.find((n) => Ft(n.startAt, n.endAt, a, !0));
}, Sa = (e, a, n, t, o) => {
  const c = o.alwaysVisible ? T(!0) : T(!1), s = T(null), m = T(!1), y = (i) => {
    const w = s.value;
    if (c.value && !m.value) {
      if (w) {
        const z = i.target;
        w.contains(z) || (c.value = !1);
      }
    } else
      m.value = !1;
  }, _ = () => {
    o.alwaysVisible === !1 && document.addEventListener("click", y, !1);
  }, Y = () => {
    o.alwaysVisible === !1 && document.removeEventListener("click", y);
  }, b = () => {
    var w, z;
    n.value = ((z = (w = document.querySelector(".calendar_wrap_month")) == null ? void 0 : w.getBoundingClientRect()) == null ? void 0 : z.height) || 0;
    const i = rt({
      date: o.checkIn,
      startDate: o.startDate,
      showYear: o.showYear
    });
    if (o.checkIn && o.checkOut) {
      const S = i - e.value;
      a.value && a.value.scrollTo({
        top: n.value * S
      });
    }
  }, u = () => {
    m.value = !0, c.value = !0, t.value && pt(() => {
      b();
    });
  }, A = () => {
    o.alwaysVisible === !1 && (m.value = !0, c.value = !1);
  }, x = () => {
    m.value = !0, c.value = !c.value, c.value && t.value && pt(() => {
      b();
    });
  };
  return at(
    () => o.alwaysVisible,
    (i) => {
      i ? (Y(), u()) : _();
    }
  ), {
    addClickOusideListener: _,
    calendarRef: s,
    closeCalendar: A,
    openCalendar: u,
    removeClickOusideListener: Y,
    showCalendar: c,
    toggleCalendar: x
  };
}, Ta = {
  key: 0,
  class: "calendar_paginate-wrapper",
  "data-testid": "calendar_paginate"
}, Ya = { class: "calendar_paginate-wrapper--left-content" }, Ba = ["disabled"], Aa = { class: "calendar_paginate-year" }, Ha = ["disabled"], Na = {
  key: 0,
  class: "calendar_wrapper_month"
}, ja = {
  key: 2,
  class: "calendar_wrapper_month"
}, za = { class: "calendar_wrapper_content-days" }, La = ["data-testid", "onMouseenter", "onClick"], Ea = ["data-testid", "onClick"], Pa = { class: "calendar_day--day-number" }, Fa = { key: 3 }, qa = {
  name: "VueCalendar"
}, Ua = /* @__PURE__ */ ge({
  ...qa,
  props: {
    alwaysVisible: {
      type: Boolean,
      default: !1
    },
    bookedDates: {
      type: Array,
      default: () => []
    },
    bookingColor: {
      type: Object,
      default: () => ({})
    },
    bookingDates: {
      type: Array,
      default: () => []
    },
    checkIn: {
      type: [Date, String],
      default: null
    },
    checkOut: {
      type: [Date, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    disabledDaysAfterDayDate: {
      type: Boolean,
      default: !1
    },
    disabledDaysBeforeDayDate: {
      type: Boolean,
      default: !0
    },
    endDate: {
      type: Date,
      default: new Date((/* @__PURE__ */ new Date()).getFullYear() + 2, 11, 1)
    },
    formatDate: {
      type: String,
      default: "YYYY-MM-DD"
    },
    isAffixed: {
      type: Boolean,
      default: !1
    },
    hasFooter: {
      type: Boolean,
      default: !1
    },
    hasHeader: {
      type: Boolean,
      default: !1
    },
    locale: {
      type: String,
      default: "fr"
    },
    minNights: {
      type: Number,
      default: 1
    },
    periodDates: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: Object,
      default: () => ({
        checkIn: "Arrivée",
        checkOut: "Départ"
      })
    },
    position: {
      type: String,
      default: "left"
    },
    showInputCalendar: {
      type: Boolean,
      default: !0
    },
    showYear: {
      type: Boolean,
      default: !1
    },
    singleCalendar: {
      type: Boolean,
      default: !1
    },
    startDate: {
      type: Date,
      default: new Date((/* @__PURE__ */ new Date()).getFullYear() - 2, 0, 1)
    },
    translations: {
      type: Object,
      default: () => ({
        fr: {
          clearDates: "Effacer les dates",
          close: "Fermer",
          days: {
            monday: "Lun",
            tuesday: "Mar",
            wednesday: "Mer",
            thursday: "Jeu",
            friday: "Ven",
            saturday: "Sam",
            sunday: "Dim"
          },
          today: "Aujourd'hui",
          periodType: {
            weeklyBySaturday: "%{minimumDuration} semaine min. du samedi au samedi || %{minimumDuration} semaines min. du samedi au samedi",
            weeklyBySunday: "%{minimumDuration} semaine min. du dimanche au dimanche || %{minimumDuration} semaines min. du dimanche au dimanche",
            weeklyByMonday: "%{minimumDuration} semaine min. du lundi au lundi || %{minimumDuration} semaines min. du lundi au lundi",
            nightly: "Un minimum de %{minimumDuration} nuit est requis || Un minimum de %{minimumDuration} nuits est requis"
          },
          halfDay: {
            checkIn: "Fin de séjour possible",
            checkOut: "Début de séjour possible"
          }
        },
        en: {
          clearDates: "Clear dates",
          close: "Close",
          days: {
            monday: "Mo",
            tuesday: "Tu",
            wednesday: "We",
            thursday: "Th",
            friday: "Fr",
            saturday: "Sa",
            sunday: "Su"
          },
          today: "Today",
          periodType: {
            weeklyBySaturday: "From Saturday to Saturday",
            weeklyBySunday: "From Sunday to Sunday",
            weeklyByMonday: "From Monday to Monday",
            nightly: "A minimum of %{minimumDuration} night is required"
          },
          halfDay: {
            checkIn: "Possible end of stay",
            checkOut: "Possible start of stay"
          }
        }
      })
    },
    timezone: {
      type: String,
      default: "Europe/Paris"
    }
  },
  emits: [
    "clear-dates",
    "close-date-picker",
    "render-next-date",
    "render-previous-date",
    "select-booking-date",
    "update:checkIn",
    "update:checkOut"
  ],
  setup(e, { expose: a, emit: n }) {
    const t = e;
    M.tz.setDefault(t.timezone), M.locale(t.locale);
    const o = typeof window < "u", c = (r, l = null) => {
      const O = t.translations[t.locale];
      if (r.includes(".")) {
        const h = r.split("."), J = O[h[0]][h[1]];
        if (J.includes("||")) {
          const ve = J.split("||");
          return l === 1 ? ve[0].replace(
            "%{minimumDuration}",
            l
          ) : ve[1].replace(
            "%{minimumDuration}",
            l
          );
        }
        return J.includes("%{minimumDuration}") ? J.replace("%{minimumDuration}", l) : J;
      } else
        return O[r];
    };
    fn("t", c);
    const s = T(0), m = T(0), y = T(null), _ = T({}), Y = T(null), b = T(0), u = T("YYYY-MM-DD"), A = T(0), x = T([]), i = T(null), w = T(null), z = T(null), S = T([]), F = T(null), H = T(null), N = T([]), U = T(/* @__PURE__ */ new Date());
    t.checkIn && t.checkOut && (n("update:checkIn", tt(t.checkIn), !1), n("update:checkOut", tt(t.checkOut), !1));
    const V = Z(() => ga()), X = Z(() => !V.value), ee = (r) => {
      const l = rt({
        date: new Date(r),
        startDate: t.startDate,
        showYear: t.showYear
      });
      s.value = Math.floor(l);
    };
    t.checkIn && t.checkOut ? ee(t.checkIn) : ee(U.value), m.value = rt({
      date: U.value,
      startDate: t.startDate,
      showYear: t.showYear
    }), S.value.push(Vt(t.startDate));
    const q = Mt(t.startDate, t.endDate), B = Ma(t.startDate, q);
    S.value.push(...B);
    const {
      addClickOusideListener: Ie,
      calendarRef: je,
      closeCalendar: p,
      openCalendar: v,
      removeClickOusideListener: d,
      showCalendar: k,
      toggleCalendar: f
    } = Sa(
      m,
      y,
      A,
      V,
      t
    ), D = Z(() => t.periodDates ? [...t.periodDates].sort((l, O) => {
      const h = l.startAt.split("/").reverse().join(), J = O.startAt.split("/").reverse().join();
      return h < J ? -1 : h > J ? 1 : 0;
    }).map((l) => {
      const O = l.periodType.includes("weekly") ? l.minimumDuration * 7 : l.minimumDuration;
      return {
        ...l,
        minimumDurationNights: O
      };
    }) : []), $ = Z(() => Ue(
      D,
      "weekly_by_saturday",
      u.value
    )), L = Z(() => Ue(
      D,
      "weekly_by_sunday",
      u.value
    )), R = Z(() => Ue(
      D,
      "weekly_by_monday",
      u.value
    )), G = Z(() => Ue(
      D,
      "nightly",
      u.value
    )), C = Ae(t, "bookingDates"), Q = Ae(t, "bookedDates"), ae = Ae(
      t,
      "bookingColor"
    );
    let ue = We(
      C.value,
      Q.value,
      ae.value,
      u
    ).disabledDates, fe = Z(() => We(
      C.value,
      Q.value,
      ae.value,
      u
    ).newBookingDates), se = Tt(
      C.value,
      ae.value,
      u
    ), j = T({});
    j = Ct(
      C.value,
      Q.value
    );
    let oe = xt(
      C.value,
      ae.value,
      u,
      j
    );
    vn(() => {
      fe = Z(() => We(
        C.value,
        Q.value,
        ae.value,
        u
      ).newBookingDates), ue = We(
        C.value,
        Q.value,
        ae.value,
        u
      ).disabledDates, se = Tt(
        C.value,
        ae.value,
        u
      ), j = Ct(
        C.value,
        Q.value
      ), oe = xt(
        C.value,
        ae.value,
        u,
        j
      ), S.value.forEach((r) => {
        r.days.forEach((l) => {
          const O = oe.value[l.formatDay];
          l.style = {
            background: j.value[l.formatDay] ? "" : ka(O, 50)
          };
        });
      });
    });
    const de = Z(() => S.value[s.value].yearKey), we = Z(() => {
      const r = t.showYear ? 12 : 2;
      return {
        left: s.value <= 0,
        right: s.value >= S.value.length - r
      };
    }), Je = (r) => {
      const l = t.showYear ? 12 : 1;
      s.value > 0 && r === "-" && (s.value -= l, n("render-previous-date", de.value)), r === "+" && (s.value += l, n("render-next-date", de.value));
    }, st = Z(() => b.value || t.minNights), Rt = Z(() => t.checkIn && t.checkOut ? Ce(
      me(t.checkIn, 1),
      qe(t.checkOut, 1),
      u.value
    ) : []), ct = Ae(t, "checkIn"), lt = Ae(t, "checkOut");
    at([ct, lt], () => {
      !ct.value && !lt.value && vt();
    });
    const it = () => {
      H.value = null, z.value = null, N.value = [];
    }, Zt = (r) => {
      var l, O;
      if (it(), D.value.length) {
        const h = (te, ce) => {
          var le;
          return (le = H.value) != null && le.minimumDurationNights ? (te == null ? void 0 : te.periodType) === "nightly" && H.value.periodType.includes("weekly") ? !0 : H.value.minimumDurationNights > ce : !1;
        }, J = () => {
          var ce;
          let te = me(r, b.value);
          if (z.value && ((ce = H.value) != null && ce.periodType.includes("weekly")) && !Re(r, z.value)) {
            let le = 0;
            H.value.periodType === "weekly_by_saturday" && (le = 6), H.value.periodType === "weekly_by_monday" && (le = 1), te = qe(
              _t(te, le),
              1
            );
          }
          return te;
        }, ve = () => {
          var ke;
          const te = J();
          let ce = [];
          const le = wt(r, te).map(
            (he) => E(he, u.value)
          );
          if (N.value.push(...le), (ke = H.value) != null && ke.periodType.includes("weekly")) {
            let he = me(
              r,
              H.value.minimumDurationNights
            ), Ee = 0;
            H.value.periodType === "weekly_by_saturday" && (Ee = 6), H.value.periodType === "weekly_by_monday" && (Ee = 1), he.getDay() !== Ee && (he = _t(
              he,
              Ee
            ), ce = wt(
              me(H.value.startAt, 1),
              qe(he, 1)
            ).map((un) => E(un, u.value)));
          }
          N.value.push(
            ...le,
            ...ce
          ), N.value = [...new Set(N.value)], N.value = N.value.map(
            (he) => tt(he)
          ), N.value = N.value.map(
            (he) => E(he, u.value)
          );
        }, Be = (te) => {
          const ce = E(te, u.value);
          let le = null;
          return D.value.forEach((ke) => {
            ke.endAt !== ce && (ke.startAt === ce || He(ke.startAt, ke.endAt, te)) && (le = ke);
          }), le;
        }, ye = Be(r);
        if (ye) {
          z.value = qe(
            ye.endAt,
            ye.minimumDurationNights
          );
          const te = D.value.findIndex(
            (ce) => ce.startAt === ye.startAt
          );
          D.value.length > te && (H.value = D.value[te + 1]), z.value && !Re(r, z.value) && h(ye, ye.minimumDurationNights) ? (b.value = ((l = H.value) == null ? void 0 : l.minimumDurationNights) || 0, _.value = { ...H.value }, ve()) : (_.value = { ...ye }, b.value = ye.minimumDurationNights, ve());
        } else {
          const te = me(r, st.value - 1);
          H.value = Be(te), h(null, st.value) ? (b.value = ((O = H.value) == null ? void 0 : O.minimumDurationNights) || 0, _.value = { ...H.value }, ve()) : b.value = 0;
        }
      }
    }, ut = Z(() => {
      if (w.value) {
        const { minimumDuration: r, periodType: l } = w.value;
        if (l === "weekly_by_saturday")
          return c("periodType.weeklyBySaturday", r);
        if (l === "weekly_by_sunday")
          return c("periodType.weeklyBySunday", r);
        if (l === "weekly_by_monday")
          return c("periodType.weeklyByMonday", r);
        if (l === "nightly")
          return c("periodType.nightly", r);
      }
      if (i.value) {
        if (Le(i.value) || Ye(i.value))
          return c("halfDay.checkIn");
        if (Oe(i.value)) {
          const r = Ca(
            D,
            i.value.formatDay
          );
          return r != null && r.periodType && (r != null && r.minimumDuration) ? `${c("halfDay.checkOut")} 
 ${c(
            `periodType.${ba(r.periodType)}`,
            r.minimumDuration
          )}` : c("halfDay.checkOut");
        }
      }
      return "";
    }), Jt = Z(() => {
      const r = t.showYear ? 12 : 2;
      return S.value.slice(s.value, r + s.value);
    }), dt = Z(() => t.isAffixed ? S.value.slice(m.value, 12 + s.value) : S.value.slice(s.value, 1 + s.value)), ze = Z(() => t.singleCalendar || V.value ? dt.value : Jt.value), Ge = Z(() => E(U.value, u.value)), Gt = (r) => ({
      1: "tooltip--left",
      2: "tooltip--left",
      3: "tooltip--center",
      4: "tooltip--center",
      5: "tooltip--center",
      6: "tooltip--right",
      0: "tooltip--right"
    })[r], Kt = (r) => E(r, t.formatDate), Qt = (r) => $.value.includes(r.formatDay) && r.date.getDay() === 6 || L.value.includes(r.formatDay) && r.date.getDay() === 0 || R.value.includes(r.formatDay) && r.date.getDay() === 1, ht = (r) => $.value.includes(r.formatDay) && r.date.getDay() !== 6 || L.value.includes(r.formatDay) && r.date.getDay() !== 0 || R.value.includes(r.formatDay) && r.date.getDay() !== 1, Xt = (r) => {
      var l, O, h;
      if ((l = Y.value) != null && l.nextEnableDate) {
        const J = Yn(
          r.date,
          (O = Y.value) == null ? void 0 : O.nextEnableDate
        );
        return t.checkIn !== r.date && !J && ((h = Y.value) == null ? void 0 : h.periodType) === "nightly" && G.value.includes(r.formatDay);
      }
    }, en = (r) => t.disabledDaysBeforeDayDate && r.formatDay !== Ge.value && Re(r.date, U.value) || t.disabledDaysAfterDayDate && r.formatDay !== Ge.value && Ot(r.date, U.value) || t.checkIn && !t.checkOut && Da(r.date, t.checkIn) || ue.value.includes(r.formatDay) && !j.value[r.formatDay] || t.checkIn && F.value && Ot(r.date, F.value), ft = (r) => {
      i.value = r, (ht(r) || Xt(r)) && (w.value = mt(r)), t.checkIn && !t.checkOut && (x.value = Ce(
        t.checkIn,
        i.value.date,
        u.value
      ));
    }, tn = (r) => {
      V.value && !t.singleCalendar && ft(r);
    }, nn = (r) => {
      X.value && !t.singleCalendar && ft(r);
    }, Ke = () => {
      w.value = null, i.value = null;
    }, an = () => {
      i.value = null, Ke();
    }, Qe = (r) => {
      if (t.singleCalendar)
        n("update:checkIn", r.date), Me();
      else {
        n("update:checkIn", r.date), cn(r), Zt(r.date);
        const l = mt(r);
        Y.value = l, x.value = [], w.value = l;
      }
    }, rn = (r) => {
      n("update:checkOut", r.date), Y.value = null, x.value = [], w.value = null;
    }, on = () => {
      w.value = null, x.value = [], i.value = null;
    }, vt = () => {
      it(), Y.value = null, on(), F.value = null;
    }, sn = (r, l) => {
      var J, ve, Be;
      kt(r) && n(
        "select-booking-date",
        r,
        kt(r),
        j.value[r.formatDay],
        l
      );
      const O = !!((J = j.value[r.formatDay]) != null && J.checkIn) && !!t.checkIn && !t.checkOut;
      (ve = j.value[r.formatDay]) != null && ve.checkIn && ((Be = j.value[r.formatDay]) != null && Be.checkOut) || Te(r) && !O || (t.singleCalendar ? t.checkIn === r.date ? n("update:checkIn", null) : Qe(r) : t.checkIn === r.date ? (n("update:checkIn", null), n("update:checkOut", null), vt()) : t.checkIn && !t.checkOut || Te(r) && Ye(r) && t.checkIn ? (rn(r), Y.value = null, F.value = null, i.value = null, p()) : t.checkIn ? (Qe(r), n("update:checkOut", null)) : Qe(r));
    }, cn = (r) => {
      var l;
      if (fe.value.length) {
        let O = r.date;
        (l = j.value[r.formatDay]) != null && l.checkOut && (O = me(r.date, 1)), F.value = xa(
          fe,
          O
        );
      }
    }, mt = (r) => {
      const l = t.periodDates.find((O) => {
        if (O.endAt !== r.formatDay && (O.startAt === r.formatDay || He(
          O.startAt,
          O.endAt,
          r.formatDay
        )))
          return O;
      });
      if (l) {
        const h = (l.periodType === "weekly_by_saturday" || l.periodType === "weekly_by_sunday" || l.periodType === "weekly_by_monday" ? "week" : "day") === "week" ? l.minimumDuration * 7 : l.minimumDuration;
        return {
          ...l,
          nextEnableDate: me(r.date, h)
        };
      }
      return null;
    }, Se = (r) => se.value.some((l) => l.value.includes(r.formatDay)), Te = (r) => r.belongsToThisMonth && Se(r) && !Oe(r), Ye = (r) => {
      var l;
      return !!t.checkIn && !!((l = j.value[r.formatDay]) != null && l.checkIn);
    }, Le = (r) => {
      var l;
      return !t.checkIn && !!((l = j.value[r.formatDay]) != null && l.checkIn);
    }, yt = (r) => {
      var h, J;
      const l = !!((h = j.value[r.formatDay]) != null && h.checkIn) && !t.checkIn, O = !!((J = j.value[r.formatDay]) != null && J.checkIn) && !!t.checkIn && !!t.checkOut;
      return l || O;
    }, Oe = (r) => {
      var l;
      return !!((l = j.value[r.formatDay]) != null && l.checkOut);
    }, kt = (r) => C.value.some(
      (l) => He(l.checkInDate, l.checkOutDate, r.formatDay)
    ) ? {
      ...C.value.find(
        (l) => He(
          l.checkInDate,
          l.checkOutDate,
          r.formatDay
        )
      ),
      ...Xe(r)
    } : C.value.some((l) => l.checkInDate === r.formatDay) && C.value.some((l) => l.checkOutDate === r.formatDay) ? {
      1: C.value.find((l) => l.checkInDate === r.formatDay),
      2: C.value.find((l) => l.checkOutDate === r.formatDay)
    } : C.value.some((l) => l.checkInDate === r.formatDay) ? {
      ...C.value.find((l) => l.checkInDate === r.formatDay),
      ...Xe(r)
    } : C.value.some((l) => l.checkOutDate === r.formatDay) ? {
      ...C.value.find((l) => l.checkOutDate === r.formatDay),
      ...Xe(r)
    } : null, Xe = (r) => {
      if (se.value.some((l) => l.value.includes(r.formatDay)) && r.belongsToThisMonth) {
        const l = se.value.find(
          (O) => O.value.includes(r.formatDay)
        );
        if (l)
          return l;
      }
      return null;
    }, Me = () => {
      p(), n("close-date-picker");
    }, _e = () => {
      n("update:checkIn", null), n("update:checkOut", null), n("clear-dates");
    }, et = () => {
      if (o) {
        const r = window.innerHeight * 0.01;
        document.documentElement.style.setProperty("--vh", `${r}px`);
      }
    }, Dt = Z(() => {
      const r = Mt(t.startDate, U.value) + 1;
      return q - r;
    }), ln = (r) => {
      const l = A.value * (ze.value.length - 4), { scrollTop: O } = r.target;
      if (l < O && ze.value.length <= Dt.value)
        s.value = s.value + 6, n("render-next-date", de.value);
      else if (ze.value.length === Dt.value)
        return null;
    };
    return at(
      () => t.showYear,
      () => {
        ee(U.value);
      }
    ), mn(() => {
      Ie(), o && V.value && (window.addEventListener("resize", et), et());
    }), yn(() => {
      d(), o && V.value && window.removeEventListener("resize", et);
    }), a({
      activeIndex: s,
      clearDates: _e,
      closeCalendar: p,
      closeDatePicker: Me,
      openCalendar: v,
      showCalendar: k,
      toggleCalendar: f
    }), (r, l) => (I(), P("div", {
      ref_key: "calendarRef",
      ref: je,
      class: ie(["vue-calendar", { "vue-calendar--disabled": e.disabled }])
    }, [
      e.showInputCalendar ? (I(), re(da, {
        key: 0,
        class: ie({ "calendar_input-open": g(k) }),
        placeholder: e.placeholder,
        "single-calendar": e.singleCalendar,
        "check-in": e.checkIn,
        "check-out": e.checkOut,
        "day-format": Kt,
        onOpenCalendar: g(v),
        onClearDates: _e
      }, null, 8, ["class", "placeholder", "single-calendar", "check-in", "check-out", "onOpenCalendar"])) : K("", !0),
      W("div", null, [
        e.alwaysVisible ? (I(), P("div", Ta, [
          W("div", Ya, [
            W("button", {
              "data-testid": "calendar_paginate-prev--button",
              type: "button",
              disabled: g(we).left,
              class: "calendar_paginate-button",
              onClick: l[0] || (l[0] = (O) => Je("-"))
            }, [
              xe(pe, { name: "chevronLeft" })
            ], 8, Ba),
            W("div", Aa, [
              W("span", null, ne(g(de)), 1)
            ]),
            W("button", {
              "data-testid": "calendar_paginate-next--button",
              type: "button",
              disabled: g(we).right,
              class: "calendar_paginate-button",
              onClick: l[1] || (l[1] = (O) => Je("+"))
            }, [
              xe(pe, { name: "chevronRight" })
            ], 8, Ha),
            W("button", {
              type: "button",
              class: "calendar_today-button",
              onClick: l[2] || (l[2] = (O) => ee(U.value))
            }, ne(c("today")), 1)
          ]),
          Ve(r.$slots, "header")
        ])) : K("", !0)
      ]),
      g(k) ? (I(), P("div", {
        key: 1,
        class: ie([
          "calendar_wrapper",
          `calendar_wrapper--${e.position}`,
          {
            "calendar_wrapper--year": e.showYear,
            "calendar_wrapper--visible": e.alwaysVisible,
            "calendar_wrapper--affix": e.isAffixed,
            "calendar_wrapper--single": e.singleCalendar
          }
        ])
      }, [
        !e.alwaysVisible && !e.isAffixed ? (I(), re(ca, {
          key: 0,
          "active-index": s.value,
          "show-header": g(V) || e.singleCalendar,
          months: g(S),
          onPaginate: Je
        }, null, 8, ["active-index", "show-header", "months"])) : K("", !0),
        e.hasHeader && g(V) ? (I(), re($t, {
          key: 1,
          "is-mobile": g(V),
          locale: e.locale,
          onCloseDatePicker: Me,
          onClearDates: _e
        }, {
          footer: gt(() => [
            Ve(r.$slots, "calendar-header-mobile", {
              clearDates: _e,
              closeDatePicker: Me
            })
          ]),
          _: 3
        }, 8, ["is-mobile", "locale"])) : K("", !0),
        W("div", {
          ref_key: "calendarWrapperContent",
          ref: y,
          onScroll: ln,
          class: ie([
            "calendar_wrapper_content",
            {
              "calendar_wrapper_content--year": e.showYear
            }
          ])
        }, [
          (I(!0), P(De, null, nt(g(ze), (O) => (I(), P("div", {
            key: O.monthKey,
            class: "calendar_wrap_month"
          }, [
            g(X) && e.alwaysVisible ? (I(), P("span", Na, ne(O.monthName), 1)) : K("", !0),
            g(X) ? (I(), re(qt, {
              key: 1,
              locale: e.locale
            }, null, 8, ["locale"])) : K("", !0),
            e.isAffixed ? (I(), P("div", ja, [
              W("span", null, ne(O.monthName), 1)
            ])) : K("", !0),
            W("div", za, [
              (I(!0), P(De, null, nt(O.days, (h) => (I(), P("div", {
                key: h.formatDay,
                class: ie([
                  "calendar_day-wrap",
                  // Tooltip
                  `calendar_day-wrap-${Gt(h.dayIndex)}`,
                  {
                    "calendar_day-wrap--no-border": !h.belongsToThisMonth,
                    "calendar_day-wrap--disabled": en(h)
                  }
                ]),
                "data-testid": `daywrap-${g(E)(h.date, u.value)}`,
                onMouseenter: (J) => nn(h),
                onMouseleave: an,
                onClick: (J) => tn(h)
              }, [
                h.belongsToThisMonth && i.value && i.value.date === h.date && w.value ? (I(), re(It, {
                  key: 0,
                  "tooltip-text": g(ut),
                  onRemoveTooltip: Ke,
                  "data-testid": "calendar_tooltip"
                }, null, 8, ["tooltip-text"])) : !yt(h) && h.belongsToThisMonth && i.value && i.value.date === h.date && (Le(h) || Oe(h) || Ye(h)) ? (I(), re(It, {
                  key: 1,
                  "tooltip-text": g(ut),
                  onRemoveTooltip: Ke,
                  "data-testid": "calendar_tooltip"
                }, null, 8, ["tooltip-text"])) : K("", !0),
                h.belongsToThisMonth ? (I(), P("button", {
                  key: 2,
                  type: "button",
                  style: Ze(h.style),
                  class: ie([
                    // Basic style
                    "calendar_day z-5",
                    // Today
                    {
                      "calendar_day--today": g(Ge) === h.formatDay
                    },
                    // CheckIn
                    {
                      "calendar_day--checkIn": g(E)(e.checkIn, u.value) === g(E)(h.date, u.value)
                    },
                    // singleCalendar
                    {
                      "calendar_day--checkIn--single": e.singleCalendar && g(E)(e.checkIn, u.value) === g(E)(h.date, u.value)
                    },
                    // CheckOut
                    {
                      "calendar_day--checkOut": g(E)(e.checkOut, u.value) === g(E)(h.date, u.value)
                    },
                    // Booking date
                    {
                      "calendar_day--booking": Te(h) && !Ye(h) && !Le(h) && !Oe(h)
                    },
                    // Hovering date
                    {
                      "calendar_day--hovering": g(X) && (!e.checkIn && i.value && g(E)(e.checkIn, u.value) !== g(E)(h.date, u.value) && i.value.date === h.date || x.value.includes(h.formatDay))
                    },
                    {
                      "calendar_day_between--checkIn-checkOut": g(zn)(e.checkIn, e.checkOut) >= 2 && g(Rt).includes(h.formatDay)
                    },
                    {
                      "calendar_day--hovering-checkIn": g(X) && i.value && e.checkIn && i.value.date === h.date
                    },
                    // Inactive saturday / sunday / monday period
                    {
                      "calendar_day--in-period event-none": ht(h) && !Te(h) || N.value.includes(h.formatDay) && !Te(h)
                    },
                    // Inactive saturday / sunday / monday period
                    {
                      "calendar_day--is-a-day-period": Qt(h)
                    },
                    // halfDay checkIn
                    {
                      "calendar_day-in-half-day--checkIn": !Se(h) && yt(h)
                    },
                    {
                      "calendar_day-in-half-day--checkOut": !Se(h) && Oe(h)
                    }
                  ]),
                  "data-testid": `day-${g(E)(h.date, u.value)}`,
                  onClick: (J) => sn(h, J)
                }, [
                  !e.singleCalendar && g(E)(e.checkIn, u.value) === g(E)(h.date, u.value) ? (I(), re(Fe, {
                    key: 0,
                    day: h,
                    "is-check-in": !0,
                    "is-check-out": !1
                  }, null, 8, ["day"])) : K("", !0),
                  !e.singleCalendar && g(E)(e.checkOut, u.value) === g(E)(h.date, u.value) ? (I(), re(Fe, {
                    key: 1,
                    day: h,
                    "is-check-in": !1,
                    "is-check-out": !0
                  }, null, 8, ["day"])) : K("", !0),
                  !e.singleCalendar && Se(h) && (Ye(h) || Le(h)) ? (I(), re(Fe, {
                    key: 2,
                    "booking-style": g(oe),
                    day: h,
                    "is-check-in": !0,
                    "is-check-out": !1
                  }, null, 8, ["booking-style", "day"])) : K("", !0),
                  !e.singleCalendar && Se(h) && Oe(h) ? (I(), re(Fe, {
                    key: 3,
                    "booking-style": g(oe),
                    day: h,
                    "is-check-in": !1,
                    "is-check-out": !0
                  }, null, 8, ["booking-style", "day"])) : K("", !0),
                  W("span", Pa, ne(h.dayNumber), 1)
                ], 14, Ea)) : (I(), P("span", Fa))
              ], 42, La))), 128))
            ])
          ]))), 128))
        ], 34),
        g(X) && e.hasFooter ? (I(), re($t, {
          key: 2,
          "is-mobile": g(V),
          locale: e.locale,
          onCloseDatePicker: Me,
          onClearDates: _e
        }, {
          footer: gt(() => [
            Ve(r.$slots, "calendar-footer", {
              clearDates: _e,
              closeDatePicker: Me
            })
          ]),
          _: 3
        }, 8, ["is-mobile", "locale"])) : K("", !0)
      ], 2)) : K("", !0)
    ], 2));
  }
});
export {
  Ua as Calendar
};
